import { z } from 'zod';
import type { LightRecipeDoc } from '@ledium/types';
import { nameSchema, descriptionSchema, spectrogramPointSchema, csvDataPointSchema, spectrogramRangesSchema } from './primitives.js';

type LightRecipeInput = Omit<LightRecipeDoc, '_id' | 'locked' | 'linked' | 'sed'> & { sed?: number };

export const lightRecipeSchema: z.ZodType<LightRecipeInput> = z.object({
    name: nameSchema,
    description: descriptionSchema,
    spectrogram: z.array(spectrogramPointSchema),
    spectrogramRanges: spectrogramRangesSchema,
    csvData: z.array(csvDataPointSchema),
    sed: z.number().optional()
});
